export const isProduction = process.env.NODE_ENV === "production";
const prodBackEndUrl = "https://schooladminapi.auokka.com"; 

export const backEndBaseURL = isProduction ? prodBackEndUrl : 'http://192.168.15.8:5023';
export const googleMapApiKey = "AIzaSyD6710nxRY5KzD5rfHOjaFFE_diB7b8AQA";

export const encryptedPassword = "*ENCRYPTEDPASSWORD*";


